export const TYPE_NATCOM_VMAIL_AIRTIME = "TYPE_NATCOM_VMAIL_AIRTIME";

export const TYPE_NATCOM_DIGICEL_VMAIL = "TYPE_NATCOM_DIGICEL_VMAIL";
export const TYPE_NATCOM_NTM = "TYPE_NATCOM_NTM";
export const TYPE_NATCOM_AIRTIME = "TYPE_NATCOM_AIRTIME";
